var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, headerAttributes, id, title, validationId) {
      


































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}
pug_mixins["fieldset"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
fieldsetCounter++;
title = attributes.title || ''
delete attributes.title
headerAttributes = {}
if (!attributes.noCollapse) {
headerAttributes['ng-click'] = 'fieldset'+ fieldsetCounter +'.closed = !fieldset'+ fieldsetCounter +'.closed'
}
if (attributes.closed) {
headerAttributes['ng-init'] = 'fieldset'+ fieldsetCounter +'.closed =' + attributes.closed
delete attributes.closed
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "bigbox"},attributes]), true)) + "\u003E\u003Cdiv" + (pug.attrs(pug.merge([{"class": "header"},headerAttributes]), true)) + "\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
if (!attributes.noCollapse) {
pug_html = pug_html + "\u003Cspan" + (" class=\"openable\""+pug.attr("ng-class", '{selected: !fieldset'+ fieldsetCounter +'.closed}', true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"main\""+pug.attr("ng-hide", 'fieldset'+ fieldsetCounter +'.closed', true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\" ng-if=\"!$editCtrl.loading.main\"\u003EEMPLOYEE: {{$editCtrl.employee_id}} | {{ $editCtrl.BONUS_COMPONENTS_BY_NAME[$editCtrl.BonusService.getBonusComponentName($editCtrl.bonus)].display.title}},  {{ $editCtrl.bonus.bonus_value | currency }} {{$editCtrl.BONUS_STATES_BY_ID[$editCtrl.bonus.state].display}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch4\u003E{{ $editCtrl.BONUS_COMPONENTS_BY_NAME[$editCtrl.BonusService.getBonusComponentName($editCtrl.bonus)].display.title }}\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EStatus:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.BONUS_STATES_BY_ID[$editCtrl.bonus.state]['display']}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BonusService.isBBGRelevantForComponent($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EBBG:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.BONUS_PAYMENT_TYPES_BY_ID[$editCtrl.bonus.checkout_config.bonus_payment_type]['display'] || '-'}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EBetrag:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ !!$editCtrl.bonus.checkout_config.per_month_value ? ($editCtrl.bonus.checkout_config.per_month_value | currency) : '-' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EZeitraum:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.getComponentDisplayStartDate($editCtrl.bonus) | date:'dd.MM.yyyy'}} - {{ $editCtrl.getComponentDisplayEndDate($editCtrl.bonus) | date:'dd.MM.yyyy'}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EGesamt:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.bonus.checkout_config.value | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BIKELEASING_BONUS_NAMES.includes($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EListenpreis:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.bonus.checkout_config.tax_base_amount | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BIKELEASING_BONUS_NAMES.includes($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EBruttokaufpreis:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.bonus.checkout_config.full_amount | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BIKELEASING_BONUS_NAMES.includes($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EURL Freigabe:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E\u003Ca ng-href=\"{{ $editCtrl.bonus.checkout_config.validation_url }}\"\u003ELINK\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BIKELEASING_BONUS_NAMES.includes($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EFreigabecode:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.bonus.checkout_config.validation_code }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$editCtrl.BIKELEASING_BONUS_NAMES.includes($editCtrl.BonusService.getBonusComponentName($editCtrl.bonus))\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EContract ID:\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv\u003E{{ $editCtrl.bonus.checkout_config.contract_id }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cdiv\u003EDokumente:\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$editCtrl.generateBonusContract()\"\u003EBonusvertrag\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cdiv class=\"hide-overflow\" ng-repeat=\"file in $editCtrl.bonus_files\"\u003E\u003Ca ng-click=\"$editCtrl.openDocument(file)\"\u003E{{file.filename}}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$editCtrl.bonus_files.length === 0\"\u003E\u003Cdiv\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\" overlay=\"$editCtrl.loading.main\"\u003E\u003Cdiv class=\"columns\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan class=\"strong\"\u003EComponent\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ $editCtrl.BONUS_COMPONENTS_BY_NAME[$editCtrl.BonusService.getBonusComponentName($editCtrl.bonus)].display.title}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cp class=\"strong\"\u003EGesamt\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ $editCtrl.bonus.bonus_value | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cp class=\"strong\"\u003EStatus\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{$editCtrl.BONUS_STATES_BY_ID[$editCtrl.bonus.state].display}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Cdatepicker class=\"date\" date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$editCtrl.bonus.dates.checkout_date","disabled": pug.escape(true),"title": "Checkout","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-string-model":"true","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Cdatepicker class=\"date\" date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$editCtrl.models.change.new_begin_date","title": "Beginn","required": pug.escape(true),"attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-use-utc":"true","ng-change":"$editCtrl.beginDateChanged()","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Cdatepicker class=\"date\" date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$editCtrl.bonus.dates.bonus_end_date","disabled": pug.escape(true),"title": "Ende","attributes": {"vn-date":"true","vn-date-reformat":"true","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$editCtrl.models.change.comment","required": pug.escape(true),"title": "Kommentar","validationMessages": {"required":"Es wird eine Eingabe benötigt."},"placeholder": "Kommentar\u002F Korrekturhinweis..."}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "$editCtrl.forms.change.bonus_edit_form","id": "$editCtrl.forms.bonus_edit_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$editCtrl.canUpdateBonus()\" overlay=\"$editCtrl.loading.update_bonus\" ng-click=\"$editCtrl.updateBonus()\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$editCtrl.canUpdateBonusSameDate()\" ng-if=\"$editCtrl.to_allow_same_day_change\" overlay=\"$editCtrl.loading.update_bonus\" ng-click=\"$editCtrl.updateBonusSameDate()\"\u003ESpeichern Same Day\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$editCtrl.exit()\"\u003EAbbrechen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"title": "Bearbeiten","ng-if": "$editCtrl.bonusIsEditable()"}
});
pug_html = pug_html + "\u003Cbr\u003E";
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-12 text-left\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "$editCtrl.models.decline.decline_comment","title": "Dieser Kommentar wird dem Mitarbeiter übermittelt.","required": pug.escape(true),"validationMessages": {"required":"Es wird eine Eingabe benötigt."},"placeholder": "Kommentar\u002F Korrekturhinweis..."}
});
},
attributes: {"name": "$editCtrl.forms.decline.decline_comment_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 right\"\u003E\u003Cbutton class=\"button button-primary right\" ng-disabled=\"!$editCtrl.canDecline()\" overlay=\"$editCtrl.loading.decline\" ng-click=\"$editCtrl.declineBonus()\"\u003EWahlleistung final ablehnen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","title": "Ablehnen","closed": "!is_neo_PC"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003C!-- show the empty while loading--\u003E";
pug_mixins["fieldset"].call({
attributes: {"class": "form-padding","title": "Warenkorb","ng-if": "$editCtrl.bonusIsPC() &amp;&amp; !basket","closed": true}
});
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cmpp-basket-component basket=\"basket\" options=\"{override_allow_editing: false}\"\u003E\u003C\u002Fmpp-basket-component\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","title": "Warenkorb","ng-if": "$editCtrl.bonusIsPC() &amp;&amp; basket","closed": true}
});
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\" overlay=\"$editCtrl.loading.main\"\u003E\u003Cadministration-cashback-review  [bonus-id]=\"$editCtrl.bonus_id\"\u003E\u003C\u002Fadministration-cashback-review\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","title": "Cashback Requests","ng-if": "$editCtrl.isCashbackBonus"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "headerAttributes" in locals_for_with ?
        locals_for_with.headerAttributes :
        typeof headerAttributes !== 'undefined' ? headerAttributes : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;